import axios from "axios";

export const configureAxios = (accessToken = null) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  if (accessToken)
    axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  axios.defaults.headers.post["Content-Type"] = "application/json";
};
